import authFormLabel from '../../Auth/utils/authFormLabel';
import { CustomerSignUpField, ProfileField } from '../../../utils/forms';

const signUpFormLabels = {
  ...authFormLabel,
  [CustomerSignUpField.BILLING_ADDRESS_LINE_1]: 'Billing address',
  [CustomerSignUpField.COMPANY_NAME]: 'Business name or ABN',
  [CustomerSignUpField.OCCUPATION]: 'Type of work',
  [CustomerSignUpField.OCCUPATION_OTHER]: 'Other type of work',
  [ProfileField.EMAIL]: 'Email address',
  [ProfileField.FIRST_NAME]: 'First name',
  [ProfileField.LAST_NAME]: 'Last name',
};

export default signUpFormLabels;
